<template>
  <div>
    <navbar></navbar>
    <main-box></main-box>
    <footerContent class="footerContent"></footerContent>
  </div>
</template>

<script>
import navbar from '@/components/navbar'
import mainBox from './mainBox'
import footerContent from '@/components/footerContent'
import { mapMutations } from 'vuex'

export default {
  name: 'Receipt',
  components: {
    navbar,
    mainBox,
    footerContent
  },
  created () {
    this.clearRemainingTimer()
  },
  methods: {
    ...mapMutations(['clearRemainingTimer'])
  }
}
</script>

<style lang="scss" scoped>
::v-deep .footer .social-bar {
  display: none;
}

::v-deep .cw-main_navbar {
  margin-bottom: 0;
}

@media (max-width: 991px) {
  .footerContent {
    display: none;
  }
}
</style>
